export default (attribute) => {
  const key =
    attribute === 'last_period'
      ? 'companies_overview.period_selection.short.last_period'
      : `companies_overview.filters.client_attribute.${attribute}`

  return I18n.t(key)
}
